import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * End call SVG Icon for end call call control button.
 */
export const EndCall: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 28 28"
    aria-hidden={true}
    {...props}
  >
    <path
      d="M18.9792 10.8487C15.7529 9.79849 12.247 9.7985 9.02067 10.8487L9.02067 14.1733C9.02067 14.5964 8.78644 14.9515 8.43887 15.1329C7.31306 15.6996 6.25525 16.4551 5.31078 17.3996C5.11038 17.6 4.83859 17.7126 4.5552 17.7126C4.2718 17.7126 4.00001 17.6 3.79962 17.3996L1.15509 14.7551C0.954701 14.5547 0.842121 14.2829 0.842121 13.9995C0.842121 13.7161 0.954701 13.4443 1.15509 13.2439C4.56176 9.83727 9.18218 7.92343 13.9999 7.92343C18.8177 7.92343 23.4381 9.83727 26.8448 13.2439C27.0452 13.4443 27.1577 13.7161 27.1577 13.9995C27.1577 14.2829 27.0452 14.5547 26.8448 14.7551L24.2002 17.3996C23.9998 17.6 23.7281 17.7126 23.4447 17.7126C23.1613 17.7126 22.8895 17.6 22.6891 17.3996C21.7446 16.4551 20.6868 15.6996 19.561 15.1329C19.2134 14.9515 18.9792 14.5964 18.9792 14.1733L18.9792 10.8487Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
